import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/motion";
import LegalModal from "@/components/alta/LegalModal";
import { LEGAL_DOCS } from "@/data/legal";

const NAV = [
  { to: "/", label: "Inicio" },
  { to: "/como-funciona", label: "Cómo funciona" },
  { to: "/servicio", label: "Servicio" },
  { to: "/para-comercios", label: "Para comercios" },
  { to: "/faq", label: "Preguntas frecuentes" },
  { to: "/alta", label: "Darme de alta" },
];

const LEGAL = [
  { key: "privacidad", label: "Política de privacidad", testid: "footer-legal-privacidad" },
  { key: "aviso", label: "Aviso legal", testid: "footer-legal-aviso" },
  { key: "cookies", label: "Política de cookies", testid: "footer-legal-cookies" },
];

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(null);
  const active = legalOpen ? LEGAL_DOCS[legalOpen] : null;
  return (
    <footer className="relative bg-abyss border-t border-silver/10 overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12 pt-24 pb-10">
        <FadeUp>
          <Link to="/alta" data-testid="footer-cta-alta" className="group block mb-20">
            <span className="font-mono text-[11px] tracking-[0.35em] text-glow/80 block mb-6">
              TU PRÓXIMA INCIDENCIA YA TIENE GESTOR
            </span>
            <span className="flex flex-wrap items-center gap-6">
              <span className="font-oswald font-600 uppercase text-[13vw] lg:text-[7.5rem] leading-[0.95] tracking-tight text-offwhite group-hover:text-silver transition-colors duration-500">
                Darme de alta
              </span>
              <ArrowUpRight className="h-12 w-12 lg:h-20 lg:w-20 text-steel group-hover:text-silver group-hover:translate-x-2 group-hover:-translate-y-2 transition-[transform,color] duration-500" />
            </span>
          </Link>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-silver/10">
          <FadeUp className="md:col-span-5" delay={0.05}>
            <div className="flex items-baseline gap-2 mb-5">
              <span className="font-oswald text-2xl tracking-[0.18em] text-offwhite">APREA</span>
              <span className="font-mono text-[10px] tracking-[0.35em] text-steel">GESTORA</span>
            </div>
            <p className="text-mist text-sm leading-relaxed max-w-xs">
              Gestión de incidencias físicas para pequeños comercios. Tú detectas. Nosotros gestionamos.
            </p>
          </FadeUp>
          <FadeUp className="md:col-span-3" delay={0.1}>
            <span className="font-mono text-[10px] tracking-[0.35em] text-steel block mb-6">NAVEGACIÓN</span>
            <ul className="space-y-3">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-mist hover:text-offwhite transition-colors duration-300"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </FadeUp>
          <FadeUp className="md:col-span-2" delay={0.15}>
            <span className="font-mono text-[10px] tracking-[0.35em] text-steel block mb-6">CONTACTO</span>
            <ul className="space-y-3 font-mono text-xs text-mist">
              <li data-testid="footer-email">apreagestora@gmail.com</li>
              <li data-testid="footer-phone">[TELÉFONO]</li>
              <li>07006, Palma de Mallorca</li>
            </ul>
          </FadeUp>
          <FadeUp className="md:col-span-2" delay={0.2}>
            <span className="font-mono text-[10px] tracking-[0.35em] text-steel block mb-6">LEGAL</span>
            <ul className="space-y-3">
              {LEGAL.map((l) => (
                <li key={l.key}>
                  <button
                    type="button"
                    onClick={() => setLegalOpen(l.key)}
                    data-testid={l.testid}
                    className="text-sm text-mist hover:text-offwhite transition-colors duration-300 text-left"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </FadeUp>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <span className="font-mono text-[10px] tracking-[0.25em] text-steel">
            © 2026 APREA GESTORA
          </span>
          <span className="font-mono text-[10px] tracking-[0.25em] text-steel">
            HORARIO HÁBIL 08:00 — 20:00 · DOM Y FEST NO COMPUTAN
          </span>
        </div>
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none select-none absolute -bottom-[4vw] left-0 right-0 text-center font-oswald font-700 uppercase leading-none text-[22vw] text-outline-faint"
      >
        APREA
      </div>
      <LegalModal
        open={!!legalOpen}
        onClose={() => setLegalOpen(null)}
        title={active ? active.title : ""}
        version={null}
        doc={active ? active.doc : []}
        testid="footer-legal-modal"
      />
    </footer>
  );
}
